export default {"src":"/_next/static/media/isotype-yellow.baed231d.svg","height":104,"width":104};